const QUERIES = {
  USERS_LIST: 'users-list',
}

export {QUERIES}

export const mainSeason = { startWeek: '2025-W35', endWeek: '2026-W27' }
export const modalSeason = { startWeek: '2023-W34', endWeek: '2024-W18' }
export const seasonReferenceYear = 2025

